import { useContext } from "react";
import PermissionsContext from "../context/Permissions";

const usePermissionsContext = () => useContext(PermissionsContext);

export default usePermissionsContext;
